/**
 * The ONE place locale strings render as HTML.
 *
 * A handful of catalogue strings carry markup - <kbd>E</kbd> in the HUD
 * prompts, an <em> here and there - and they render via innerHTML today.
 * In React that is dangerouslySetInnerHTML, and this component is its single
 * greppable choke point, the same role the `html:` key played in el().
 *
 * POLICY: `k` is only ever a key into the four bundled first-party locale
 * files - never user input, never assistant output. Interpolated `values`
 * are escaped by i18next before insertion, so they cannot inject markup.
 * dangerouslySetInnerHTML anywhere else in the codebase is a review failure.
 */

import { t } from '../../i18n/i18n'
import { useLang } from './LanguageProvider'

export function LocaleHtml({
  k,
  values,
  as: Tag = 'span',
  className,
}: {
  k: string
  values?: Record<string, string | number>
  as?: 'span' | 'div' | 'h1'
  className?: string
}) {
  useLang()
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: t(k, values) }} />
}
